import React, { FC, useState } from "react";
import { Row } from "antd";
import PaymentPageHeader from "./Header";
import { IPlan, plans } from "./constants";
import Popup from "../popup";
import PlanCard from "./PlanCard";
import PaymentForm from "./PaymentForm";
import "../../App.css"; // Assuming you have some additional styles here


import { useUser } from '../../context';
import { useLocation } from 'react-router-dom';

interface Props {
  showHeader?: boolean;
}

export const PricingCards: FC<Props> = ({ showHeader }) => {
  const { user } = useUser();
  const location = useLocation();
  const [showContactForm, setShowContactForm] = useState(false);
  const [showStripeForm, setShowStripeForm] = useState(false);
  const [amount, setAmount] = useState(0);
  const [planKey, setPlanKey] = useState("standerd");


  const signInUser = (pathName: string) => {
    const baseUrl = process.env.REACT_APP_BASE_URL as string;
    const isLocalhost = baseUrl.includes('localhost') || baseUrl.includes('127.0.0.1');
    const protocol = isLocalhost ? 'http://' : 'https://';
    const cleanBaseUrl = baseUrl.replace(/^https?:\/\//, '');
    const redirectTo = `${protocol}${cleanBaseUrl}/${pathName}?path=finishSignup`;
    window.location.href = redirectTo;
  };

  const handleSignup = () => {
    const path = process.env.REACT_APP_OFFICE_AUTH_ENDPOINT;
    if (path) signInUser(path);
  };

  const handBtnClick = (selectedPlan: IPlan) => {
    const { btn, salePrice, price } = selectedPlan;
    if (btn === "Contact Us") {
      setShowContactForm(true);
    } else if (btn === "Purchase") {
      const priceInNumber = parseInt((salePrice || price || "0").toString());
      setAmount(priceInNumber);
      setPlanKey(selectedPlan.planKey || "standerd");
      setShowStripeForm(true);
    } else if (btn === "Get Started") {
      handleSignup();
    }
  };


  return (
    <div>
      {location.state?.paymentRequired && user?.category === 'recruiter' && (
        <div style={{ background: '#fffbe6', border: '1px solid #ffe58f', padding: 16, marginBottom: 24, borderRadius: 4, color: '#ad6800', textAlign: 'center' }}>
          <b>Your free trial has ended. Please subscribe to continue using Chronoflow as a recruiter.</b>
        </div>
      )}
      {showHeader && <PaymentPageHeader />}
      <div id="pricing-cards">
        <div className="pricing-section">
          <div className="container-pricing">
            <h2 className="pricing-section-title" style={{ padding: "20px 40px 10px" }}>
              Our Pricing Plans
            </h2>
            <p style={{ textAlign: "center", fontSize: "20px", color: "#555", marginTop: "0px" }}>
            Chronoflow's pricing is for recruiters — candidates and hiring managers access their dashboards for free.
            </p>
            <Row gutter={[24, 24]} justify="center" align="stretch">
              {plans.map((plan, index) => (
                <PlanCard plan={plan} key={index} onClick={() => handBtnClick(plan)} />
              ))}
            </Row>
          </div>
        </div>
      </div>
        <Popup
          visible={showContactForm}
          onClose={() => setShowContactForm(false)}
        />
        <PaymentForm
          amount={amount}
          planKey={planKey}
          open={showStripeForm}
          onCancel={() => setShowStripeForm(false)}
        />

       </div>

              
);
              };    
export default PricingCards;
